// @flow
import classNames from 'classnames';
import React from 'react';
import Icon from '../../_particles/icon/react/Icon';

export type ButtonProps = {
  link?: string,
  children?: string,
  disabled?: boolean,
  style?: 'primary' | 'secondary' | 'chromeless' | 'icon',
  type?: 'button' | 'submit',
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => any,
  icon?: string,
  iconTitle?: string,
  className?: string,
  reverse?: string,
  small?: boolean,
  ariaLabel?: string,
};

const Button = (props: ButtonProps): React.Element<any> => {
  const {
    link,
    children,
    style,
    type,
    icon,
    className,
    onClick,
    disabled,
    iconTitle,
    reverse,
    small,
    ariaLabel,
  } = props;

  const Tag = link ? 'a' : 'button';

  const classes = classNames(
    {
      button: true,
      [`button--${style || 'primary'}`]: true,
      'button--reverse': reverse,
      'button--small': small,
    },
    className
  );

  const attributes = {
    href: link,
    type: type || (!link ? 'button' : undefined),
    onClick,
    disabled,
    'aria-label': ariaLabel,
  };

  return (
    <Tag className={classes} {...attributes}>
      {icon && <Icon icon={icon} title={iconTitle} className="button__icon" />}
      {children && <span className="button__text">{children}</span>}
    </Tag>
  );
};

export default Button;
